import { stringify } from "./util";
import { installed } from "./extension";
import { percent } from "./random";

interface EpomRequest {
  key: string,
  'cp.browser': string,
  'cp.uid'?: string,
  'cp.preference'?: string,
  'cp.version'?: string,
  'cp.roles'?: string,
  'cp.installed'?: string,
  'cp.authenticated': number,
  format: 'json',
}

export interface Request {
  key: string,
  browser: string,
  userId?: string,
  preferences?: string,
  version?: string,
  roles?: string,
}

interface Response {
  beacon: string,
  code: string,
  creative?: string,
  click?: string,
  success: boolean,
}

async function fetchUnit(params: Request): Promise<Response> {
  const args: EpomRequest = {
    key: params.key,
    format: 'json',
    'cp.browser': params.browser,
    'cp.authenticated': 0,
  };

  if (params.userId?.length) {
    args['cp.uid'] = params.userId;
    args['cp.authenticated'] = 1;
  }

  if (params.preferences?.length) {
    args['cp.preference'] = params.preferences;
  }

  if (params.version?.length) {
    args['cp.version'] = params.version;
  }

  if (params.roles?.length) {
    args['cp.roles'] = params.roles;
  }

  const exts = installed();

  if (exts.length) {
    args['cp.installed'] = exts.join(',');
  }

  const url = `https://aj1549.online/edfce-api-v3?${stringify(args)}`;

  return req(url);
}

export async function placement(params: Request): Promise<HTMLElement | null> {
  const unit = await fetchUnit(params);

  if (!unit?.success) {
    return null;
  }

  const $doc = document.createElement('div');
  const $elem = document.createElement('div');
  $doc.innerHTML = unit.code;

  const $wrapper = $doc.querySelector('.wrapper');
  const $adFrame = $doc.querySelector('iframe');
  const $scriptTag = $doc.querySelector('script[src^="//"]');

  if ($wrapper) {
    const scripts: {src?: string, code?: string}[] = [];

    $wrapper.childNodes.forEach(node => {
      if (!(node instanceof HTMLScriptElement)) {
        return;
      }

      if (node.src && node.src.length) {
        scripts.push({
          src: node.src,
        });
      }

      if (node.innerText.trim().length) {
        scripts.push({
          code: node.innerText,
        });
      }

      node.remove();
    });

    scripts.forEach((script) => {
      const $script = document.createElement('script');

      if (script.src) {
        $script.src = script.src;
      }

      if (script.code) {
        $script.innerText = script.code;
      }

      $wrapper.appendChild($script);
    });

    $elem.appendChild($wrapper);
  } else if ($adFrame) {
    $elem.appendChild($adFrame);
  } else if ($scriptTag) {
    const script = document.createElement('script');
    script.src = $scriptTag.getAttribute('src') || '';
    $elem.appendChild(script);
  } else if (unit.click?.length && unit.creative?.length) {
    const $link = document.createElement('a');
    $link.setAttribute('href', unit.click);
    $link.setAttribute('target', '_blank');

    const $creative = document.createElement('img');
    $creative.setAttribute('src', unit.creative);

    $link.appendChild($creative);
    $elem.appendChild($link);
  } else {
    return null;
  }

  const $beacon = document.createElement('img');
  $beacon.setAttribute('src', unit.beacon);
  $beacon.setAttribute('width', '0');
  $beacon.setAttribute('height', '0');

  $elem.appendChild($beacon);

  return $elem;
}

function req(url: string) {
  const useXhr = percent(0.1);

  return (useXhr) ? reqXhr(url) : reqFetch(url);
}

function reqXhr(url: string): Promise<Response> {
  return new Promise((resolve, reject) => {
    const xhr = new XMLHttpRequest();
    xhr.open('GET', url);

    xhr.onload = function () {
      if (this.status >= 200 && this.status < 400) {
        resolve(JSON.parse(xhr.response) as Response);
      } else {
        reject({
          status: this.status,
          statusText: xhr.statusText,
          info: 'request completed',
        });
      }
    };

    xhr.onerror = function () {
      reject({
        status: this.status,
        statusText: xhr.statusText,
        info: 'request failed',
      });
    };

    xhr.send();
  });
}

async function reqFetch(url: string) {
  const res = await fetch(url, {
    credentials: 'include',
    cache: 'no-store',
  });

  return res.json() as Promise<Response>;
}
